import { useCallback, useEffect, useRef } from 'react';
import MapLocation from '@alltrails/amplitude/enums/MapLocation';
import TimeDrawerAction from '@alltrails/amplitude/enums/TimeDrawerAction';
import logMapOverlayTimeDrawerActionTapped from '@alltrails/amplitude/events/logMapOverlayTimeDrawerActionTapped';
import { getMapOverlay } from '@alltrails/maps/utils/amplitudeHelpers';
import { useAppSelector } from '../redux/helpers';

// These events are only supposed to get called once per condition type,
// so this hook keeps track of this for the consumer in order to reduce
// duplication and maintenance around this requirement.
const useLogMapOverlayTimeDrawerActionTapped = (action: TimeDrawerAction, mapLocation: MapLocation, trailId?: number, customRouteId?: number) => {
  const activeCondition = useAppSelector(state => state.conditions.activeCondition);
  const hasLoggedEvent = useRef(false);

  useEffect(() => {
    hasLoggedEvent.current = false;
  }, [activeCondition]);

  const logEvent = useCallback(
    (args?: Pick<Parameters<typeof logMapOverlayTimeDrawerActionTapped>[0], 'to_overlay'>) => {
      if (activeCondition && !hasLoggedEvent.current) {
        logMapOverlayTimeDrawerActionTapped({
          custom_route_id: customRouteId ? String(customRouteId) : undefined,
          map_location: mapLocation,
          map_overlay: getMapOverlay(activeCondition),
          time_drawer_action: action,
          trail_id: trailId ? String(trailId) : undefined,
          ...args
        });
        hasLoggedEvent.current = true;
      }
    },
    [action, activeCondition, mapLocation, trailId, customRouteId]
  );

  return logEvent;
};

export default useLogMapOverlayTimeDrawerActionTapped;
